import React, { useContext, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AuthContext from './context/AuthProvider';
import setupAxiosInterceptors from './api/interceptors';

import Tables from './Tables/Tables';
import Report from './Report/Report';
import Login from './Login';
import MainMenu from './MainMenu';
import BackOffice from './BackOffice/BackOffice';
import BOReport from './BackOffice/BOReport/BOReport';
import BOUsers from './BackOffice/BOUsers/BOUsers';
import BOTables from './BackOffice/BOTables/BOTables';
import './App.css';

function App() {
  const authContext = useContext(AuthContext);
  const { auth } = authContext;

  useEffect(() => {
    setupAxiosInterceptors(authContext);
  }, [authContext]);

  const isAdmin = auth?.isAdmin === true;

  if (auth && auth.token) {
    return (
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/" element={<MainMenu isAdmin={isAdmin} />} />
          <Route path="/login" element={<MainMenu isAdmin={isAdmin} />} />

          {auth?.tables && (
            <Route path="/tables" element={<Tables />} />
          )}

          {auth?.report && (
            <Route path="/report" element={<Report />} />
          )}

          {isAdmin && (
            <React.Fragment>
              <Route path="/backoffice" element={<BackOffice />} />
              <Route path="/boreport" element={<BOReport />} />
              <Route path="/bousers" element={<BOUsers />} />
              <Route path="/botables/*" element={<BOTables />} />
            </React.Fragment>
          )}

          <Route path="*" element={<MainMenu isAdmin={isAdmin} />} />
        </Routes>
      </Router>
    );
  } else {
    return (
      <Login />
    );
  }
}

export default App;